import { DeviceHasPassedBox } from "components/DeviceHasPassedBox/DeviceHasPassedBox"
import { TakeFotoBox } from "components/TakeFotoBox/TakeFotoBox"
import { TakeNoteBox } from "components/TakeNoteBox/TakeNoteBox"
import { VisualControl } from "components/VisualControl/VisualControl"
import { DeviceSetup, Examination, File, TestData } from "graphql/types"

type TestFollowUpProps = {
  data: TestData
  setData: (data: TestData) => void
  deviceSetup: DeviceSetup[]
  examination: Examination | undefined
}

export const TestFollowUp = (props: TestFollowUpProps) => {
  const { data, setData, deviceSetup, examination } = props

  const setImageData = (images: File[]) => {
    setData({
      ...data,
      image: images,
    })
  }

  return (
    <>
      <VisualControl data={data} setData={setData} />
      {examination && (
        <DeviceHasPassedBox
          data={data}
          setData={setData}
          deviceSetup={deviceSetup}
          examination={examination}
        />
      )}
      <TakeNoteBox data={data} setData={setData} name="Follow Up" setName={false} />
      <TakeFotoBox setImages={setImageData} images={data.image} imageName="Follow Up" />
    </>
  )
}
